import { render } from "./Event.vue?vue&type=template&id=4d62d228&ts=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__